<script setup lang="ts">
import { Select } from '@taler/ui'
import { useI18n } from 'vue-i18n'
import type { Locale } from '@/app/i18n'
import { storeLocale } from './locale-preference.ts'

const { t, locale } = useI18n({ useScope: 'global' })

const OPTIONS: ReadonlyArray<{ value: Locale; label: string }> = [
  { value: 'en', label: 'English' },
  { value: 'hu', label: 'Magyar' },
]

function choose(value: Locale): void {
  locale.value = value
  storeLocale(value)
}
</script>

<template>
  <Select
    :model-value="locale as Locale"
    :options="OPTIONS"
    :aria-label="t('shell.language')"
    variant="icon"
    @update:model-value="choose"
  >
    <template #trigger>
      <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
        <circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" stroke-width="1.4" />
        <path
          d="M2 8h12M8 2c3 3.4 3 8.6 0 12M8 2C5 5.4 5 10.6 8 14"
          fill="none"
          stroke="currentColor"
          stroke-width="1.4"
        />
      </svg>
    </template>
  </Select>
</template>
